import moment from "moment";
import { formatPhoneNumber } from "../../utils/formatPhoneNumber";
import type { ColDef, ValueFormatterParams } from "ag-grid-community";

export const agentTableColumnDefs: ColDef[] = [
  {
    field: "firstName",
    width: 200,
    cellDataType: "text",
    filter: "agTextColumnFilter",
    headerName: "First Name",
    floatingFilter: true
  },
  {
    field: "middleName",
    width: 200,
    cellDataType: "text",
    filter: "agTextColumnFilter",
    headerName: "Middle Name",
    floatingFilter: true
  },

  {
    field: "lastName",
    width: 200,
    cellDataType: "text",
    filter: "agTextColumnFilter",
    headerName: "Last Name",
    floatingFilter: true
  },

  {
    field: "preferredName",
    width: 200,
    cellDataType: "text",
    filter: "agTextColumnFilter",
    headerName: "Preferred Name",
    floatingFilter: true
  },

  {
    field: "emailAddress",
    width: 300,
    cellDataType: "text",
    filter: "agTextColumnFilter",
    headerName: "Email",
    floatingFilter: true
  },
  {
    field: "phoneNumber",
    width: 200,
    cellDataType: "text",
    filter: "agTextColumnFilter",
    headerName: "Phone #",
    floatingFilter: true,
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? formatPhoneNumber(params.value) : ""
  },
  {
    field: "createdAt",
    width: 200,
    filter: "agDateColumnFilter",
    headerName: "Created At",
    floatingFilter: true,
    valueFormatter: (params: ValueFormatterParams) => {
      return params.value
        ? `${moment(params.value).format("YYYY-MM-DD hh:mm a")}`
        : "N/A";
    }
  },
  {
    field: "updatedAt",
    width: 200,
    sort: "desc",
    filter: "agDateColumnFilter",
    headerName: "Updated At",
    floatingFilter: true,
    valueFormatter: (params: ValueFormatterParams) => {
      return params.value
        ? `${moment(params.value).format("YYYY-MM-DD hh:mm a")}`
        : "N/A";
    }
  }
];
